export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	tomohawk: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "5M"],
			aerialace: ["7M", "7L17", "5M", "5L17"],
			airslash: ["7L33", "5L37"],
			aquatail: ["7T"],
			attract: ["7M", "5M"],
			aurasphere: ["7L1", "5L1"],
			batonpass: ["7E", "5E"],
			brickbreak: ["7E", "5M"],
			bulkup: ["7M", "5M"],
			bulldoze: ["7M", "5M"],
			confide: ["7M"],
			confuseray: ["7M", "5E"],
			doubleteam: ["7M", "5M"],
			earthpower: ["5L33"],
			earthquake: ["7M", "5M"],
			echoedvoice: ["7M", "5M"],
			facade: ["7M", "5M"],
			falseswipe: ["7M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "5M"],
			fly: ["7M", "5M"],
			focusblast: ["7M", "5M"],
			focusenergy: ["7E", "5E"],
			frustration: ["7E", "5M"],
			furyswipes: ["7L1", "5L1"],
			gigaimpact: ["7M", "5M"],
			grassknot: ["7M", "5M"],
			harden: ["7L1", "5L1"],
			haze: ["7E", "5E"],
			healingwish: ["7L60", "5L60"],
			heatwave: ["7L42", "5L45"],
			helpinghand: ["7T"],
			hiddenpower: ["7M", "5M"],
			hurricane: ["7L51", "5L55"],
			hyperbeam: ["7M", "5M"],
			hypervoice: ["7L45", "5L49"],
			incinerate: ["6M", "5M"],
			irontail: ["7T"],
			memento: ["7E", "5E"],
			morningsun: ["7L20", "5L20"],
			naturepower: ["7E", "5E"],
			poweruppunch: ["6L99"],
			protect: ["7M", "5M"],
			quash: ["7M", "5M"],
			raindance: ["7M", "7L29", "5M", "5L29"],
			rapidspin: ["7E", "5E"],
			reflect: ["5M"],
			rest: ["7M", "7L53", "5M", "5L53"],
			retaliate: ["6M", "5M"],
			return: ["7M", "5M"],
			roar: ["7M", "5M"],
			rockslide: ["7M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "5M"],
			roost: ["7M", "7E", "5E"],
			round: ["7M", "5M"],
			safeguard: ["7M", "5M"],
			scratch: ["7L4"],
			secretpower: ["7M"],
			skyattack: ["7L55"],
			skydrop: ["7M", "7L49", "5M", "5L50"],
			snore: ["7T"],
			solarbeam: ["7M", "5M"],
			stealthrock: ["7E", "5E"],
			steelwing: ["7M"],
			strength: ["6M", "5M"],
			submission: ["7L37", "5L42"],
			substitute: ["7M", "5M"],
			sunnyday: ["7M", "7L1", "5M", "5L1"],
			superpower: ["7L50", "5L51"],
			swagger: ["7M", "5M"],
			taunt: ["7M", "5M"],
			thief: ["7M", "5M"],
			toxic: ["7M", "5M"],
			whirlwind: ["7L23", "5L23"],
			workup: ["7M", "5M"],
			yawn: ["7E", "5E"],
		},
	},
};
